<template>
    <div>
        <!--<div class="search-layout">-->
        <!--<swb-query-sort-area ref="query_model" :config="queryConfig" :queryKey="queryKey" :queryOnLoad="false" :queryHandler="queryHandler"></swb-query-sort-area>-->
        <!--</div>-->
        <div>
            <el-button type="primary" @click="setGoodsCat()">关联商品分类</el-button>
        </div>
        <div class="table-layout">
            <el-table :data="devcGoodsCatRelList" border style="width: 100%">
                <el-table-column prop="devcCatFullName" label="资产分类全名称" align="left"></el-table-column>
                <el-table-column prop="goodsCatFullName" label="商品分类全名称" align="left"></el-table-column>
                <el-table-column prop="creatorName" label="创建人" align="left" width="160"></el-table-column>
                <el-table-column prop="createTime" label="创建时间" align="center" width="180"></el-table-column>
                <el-table-column label="操作" align="left" width="100">
                    <template slot-scope="rows">
                        <span class="swb-btn swb-btn-link" @click="deleteRow(rows.row.id)">删除</span>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="pagination-layout mt10">
            <el-pagination background :page-size="pageSize" :page-sizes="pageSizes" :current-page="pageNumber" :total="totalCount" @current-change="handlePageChange" @size-change="handleSizeChange" layout="prev, pager, next, jumper, sizes, total"></el-pagination>
        </div>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox } from '../../app.vues'

    import { getDefaultPageSizes } from '../../../src/app.conf'

    import shopDevcApi from '../../api/shopDevc'

    import SwbQuerySortArea from '../query/QuerySortArea';
    Vue.regist(SwbQuerySortArea);

    let mockConfigData = {
        "queryFields": [{
            "type": "Text",
            "valueType": "String",
            "label": "品牌名称",
            "code": "name",
            "basic": true
        }, {
            "type": "Text",
            "valueType": "String",
            "label": "英文代码",
            "code": "code",
            "basic": true
        }, {
            "type": "Text",
            "valueType": "String",
            "label": "显示名称",
            "code": "dispName",
            "basic": true
        }],
        "sortFields": []
    };

    export default {
        name: 'swb-devc-goods-cat-rel-list',
        desc: '关联商品分类',
        props: ['devcCatId'],
        data: function () {
            return {
                pageNumber: 1,
                totalCount: 1,
                pageSize: 10,
                pageSizes: getDefaultPageSizes(),
                devcGoodsCatRelList: [],
                queryConfig: mockConfigData,
                queryKey: null,
                queryModel: {
                    filterItems: {},
                    sortItemList: [],
                    sortItems: {}
                }
            }
        },
        created: function () {
            this.pageSize = this.pageSizes.first();
            this.getDevcGoodsCatRelList();
        },
        methods: {
            handleSizeChange: function (val) {
                let curStartIndex = (this.pageNumber - 1) * this.pageSize;
                this.pageSize = val;
                let newPageNumber = Math.max(1, Math.ceil(curStartIndex / this.pageSize));
                this.handlePageChange(newPageNumber);
            },
            handlePageChange: function (val) {
                this.pageNumber = val;
                this.getDevcGoodsCatRelList();
            },
            getDevcGoodsCatRelList: function () {
                let self = this;
                let postData = {};
                postData.pagination = {
                    pageSize: self.pageSize,
                    pageNumber: self.pageNumber,
                };
                let filterItems = Utils.merge({}, this.queryModel.filterItems);
                filterItems.devcCatId = self.devcCatId;
                postData.filterItems = filterItems;
                let theLoad = MsgBox.loading();
                shopDevcApi.getDevcGoodsCatRelList(postData, function (result) {
                    theLoad.hide();
                    if(result.type === "info") {
                        //
                        self.devcGoodsCatRelList = result.data || [];
                    } else {
                        self.$message.warning(result.message);
                    }
                });
            },
            queryHandler: function (queryModel) {
                this.queryModel = queryModel;
                this.pageNumber = 1;
                this.getDevcGoodsCatRelList();
            },
            setGoodsCat: function () {
                let self = this;
                let theDlg = Vue.$showDialog({
                    title: '商品分类信息',
                    showCloseBtn: true,
                    template: '<swb-categ-tree :noPostFilters="true" :isClickEvent="false" :enableSearch = "enableSearch" :searchUseId="searchUseId" ref="swb_categ_tree"></swb-categ-tree>',
                    data: {
                        enableSearch: true,
                        searchUseId: 0
                    },
                    methods: {
                        updateDevcCatGoodsCatById: function (postData) {
                            let loading = MsgBox.loading();
                            shopDevcApi.updateDevcCatGoodsCatById(postData, function (result) {
                                loading.close();
                                if(result.type == "info") {
                                    theDlg.close();
                                    MsgBox.success("关联成功");
                                    self.getDevcGoodsCatRelList();
                                } else {
                                    MsgBox.warning(result.message);
                                }
                            })
                        }
                    },
                    okClicked: function () {
                        let result = this.$refs.swb_categ_tree.getDlgResult() || {};
                        if(result != null && result.type === 'info') {
                            let postData = {};
                            let categ = result.data;
                            postData.goodsCatIds = [categ.id];
                            postData.id = self.devcCatId;
                            this.updateDevcCatGoodsCatById(postData);
                        } else {
                            this.$message.error(result.message);
                        }
                        return false;
                    }
                });
            },
            deleteRow: function (id) {
                let self = this;
                self.$confirm('确定要删除吗？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(function () {
                    let postData = {
                        id: id
                    };
                    let loading = MsgBox.loading();
                    shopDevcApi.deleteDevcGoodsCatRelById(postData, function (result) {
                        loading.close();
                        if(result.type == "info") {
                            self.getDevcGoodsCatRelList();
                        } else {
                            MsgBox.warning(result.message);
                        }
                    })
                }).catch(function () {
                });
            },
        },
    }
</script>



// WEBPACK FOOTER //
// src/compo/categ/DevcGoodsCatRelList.vue